import {createRouter, createWebHistory} from 'vue-router'
import LoginRoutes from './login_routes'
import PublicRoutes from './public_routes'
import {getHomeApp} from '@shared-utils/auth/homeAppCookie'
import {AppUrls} from '@shared-utils/auth/appUrls'
import {redirectToExternalUrl} from '@shared-utils/url/redirectToExternalUrl'

// Login opened as part of a flow (OAuth client such as the QBO extension, a 401/logout bounce,
// a password reset, an accepted invitation, a Google error) must always show the form, even when
// a home-app cookie is present.
const LOGIN_FLOW_QUERY_PARAMS = [
  'redirect_url',
  'redirect_uri',
  'client_id',
  'state',
  'code_challenge',
  'code_challenge_method',
  'passwordReset',
  'invitationAccepted',
  'error',
]

const routes = [
  {
    path: '/',
    children: [LoginRoutes, PublicRoutes],
  },

  {
    path: '/:pathMatch(.*)*',
    redirect: '/login',
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: () => ({top: 0}),
})

function hasLoginFlowParams(query) {
  return LOGIN_FLOW_QUERY_PARAMS.some(param => query?.[param] != null)
}

function getActiveSessionHomeUrl(to) {
  if (to.name !== 'auth.login' || hasLoginFlowParams(to.query)) {
    return null
  }

  const homeApp = getHomeApp()

  if (homeApp === 'crm') {
    return AppUrls.crm()
  }

  if (homeApp === 'app') {
    return AppUrls.client()
  }

  return null
}

router.beforeEach((to, from, next) => {
  const homeUrl = getActiveSessionHomeUrl(to)

  if (homeUrl) {
    redirectToExternalUrl(homeUrl)
    next(false)
    return
  }

  next()
})

export default router
